import { useContext } from "react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import styled from "styled-components";
import { faHistory } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HoverCard, Tooltip } from "@mantine/core";

import { WorkbenchContext } from "@pages/editor/providers";

import { TimestampUpsellPopover } from "../TimestampUpsellPopover";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MOMENT_FORMAT_STRING = "MMM D, hh:mm A";

const LastEditComponent = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { remoteBundle } = workbench;
  const lastEditorName = remoteBundle?.displayProps.lastChangeBy;
  const tooltipTime = moment(remoteBundle?.displayProps.lastChangeAt);

  return (
    <Container>
      {!workbench.user ? (
        <HoverCard withArrow position="bottom">
          <HoverCard.Target>
            <FontAwesomeIcon icon={faHistory} size="lg" />
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <TimestampUpsellPopover />
          </HoverCard.Dropdown>
        </HoverCard>
      ) : (
        tooltipTime.isValid() && (
          <Tooltip
            label={
              <>
                Last edited: {tooltipTime.format(MOMENT_FORMAT_STRING)}
                {lastEditorName && <>By: {lastEditorName}</>}
              </>
            }
            position="right"
            withArrow
          >
            <FontAwesomeIcon icon={faHistory} size="lg" />
          </Tooltip>
        )
      )}
    </Container>
  );
};
export const LastEdit = observer(LastEditComponent);
